import React from 'react';
import classNames from 'classnames';
import { roundToTwoDecimalsIfDecimal } from '../../../../helpers/shared/pricing';

import styles from './item-price.module.scss';

export enum Price_Size {
  Small = 'small',
  Medium = 'medium',
  Large = 'large',
  ExtraLarge = 'xLarge',
}

export enum Price_Color {
  Dark = 'dark',
  Light = 'light',
  Black = 'black',
}

type Props = {
  price: number;
  discountedPrice?: number;
  isLeadingPrice?: boolean;
  suffix?: string;
  size?: Price_Size;
  className?: string;
  showOnlyLabel?: boolean;
  color?: Price_Color;
};

export const ItemPrice = ({
  price,
  discountedPrice,
  isLeadingPrice = false,
  suffix,
  size = Price_Size.Medium,
  className,
  showOnlyLabel = false,
  color = Price_Color.Dark,
}: Props) => {
  return (
    <div
      className={classNames(className, styles.root, {
        [styles.small]: size === Price_Size.Small,
        [styles.medium]: size === Price_Size.Medium,
        [styles.large]: size === Price_Size.Large,
        [styles.xLarge]: size === Price_Size.ExtraLarge,
        [styles.dark]: color === Price_Color.Dark,
        [styles.light]: color === Price_Color.Light,
        [styles.black]: color === Price_Color.Black,
      })}
      data-testid="item-price"
    >
      {showOnlyLabel ? <span className={styles.onlyLabel}>only</span> : null}
      {isLeadingPrice ? 'from' : undefined}
      {discountedPrice ? (
        <span className={styles.previousPrice}>
          £{roundToTwoDecimalsIfDecimal(price)?.toLocaleString('en-GB')}
        </span>
      ) : null}
      <span className={styles.price}>
        £{roundToTwoDecimalsIfDecimal(discountedPrice || price)?.toLocaleString('en-GB')}
      </span>
      {suffix && suffix}
    </div>
  );
};
